import script from "./TuningControls.vue?vue&type=script&setup=true&lang=ts"
export * from "./TuningControls.vue?vue&type=script&setup=true&lang=ts"

import "./TuningControls.vue?vue&type=style&index=0&id=bcc3cce8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bcc3cce8"]])

export default __exports__